module.exports = __webpack_public_path__ + "static/media/report.359f5c57.svg";